<script>
import {computed} from 'vue'
export default {
  inheritAttrs: false,
  props: {
    id: {
      type: [String, Number],
      default: '',
    },
    label: {
      type: String,
      required: true,
    },
    value: {
      type: [String, Number],
      required: true,
    },
    link: {
      type: String,
      default: '',
    },
    required: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Boolean,
      default: false,
    },
    variant: {
      type: String,
      default: '',
    },
    modelValue: String,
  },
  emits: ['update:modelValue'],
  setup(props){
    const checked = computed(() => {
      if(!props.modelValue){
        return false
      }
      return  props.modelValue !== '' || props.modelValue === '1' ? true : false
    })
    return {
      checked
    }
  }
}
</script>

<template>
  <label class="custom-checkbox">
    <a
      class="
        text-black
        font-semibold
        transition-colors
        duration-300
        no-underline
        hover:text-black-50 hover:underline
      "
      :href="link"
      target="_blank"
      v-if="link"
      >{{ label }}
      <span v-if="required">*</span>
    </a>
    <template v-else>{{ label }} <span v-if="required">*</span></template>
    <input
      type="checkbox"
      v-bind="$attrs"
      :id="id"
      :class="{ failed: error }"
      :value="value"
      :checked="checked"
      @input="$emit('update:modelValue', !!$event.target.checked)"
    />

    <span
      :class="
        variant === 'light'
          ? '!bg-white !border-white'
          : 'bg-gray-600 border-gray-600'
      "
    ></span>
  </label>
</template>
